import {
	$draftCampaignStyles,
	$executionsColumns,
	columnHeaders,
	sortKeys
} from 'features/contacts/utils/columns'
import { memo } from 'react'
import { ContactsTable, SearchPagination } from 'shared/ui'

import type { ContactTable as Props } from '../../types'

import { CSVExport } from '../CSVExport'
import { Exclude } from '../Exclude/Exclude'
import { CampaignContactsRow } from '../GeneralTable/InfoCells'

const HeaderActions = (props: ContactsTable.Types.ActionsProps) => [
	<CSVExport
		className={ContactsTable.css.activeControlButton}
		{...props}
		key='📦'
	>
		Export Contacts
	</CSVExport>,
	<Exclude {...props} key='➖' />
]

const Headers = () => [
	<ContactsTable.SortableHeadCells
		allowedKeys='CampaignContacts'
		columnsStore={$executionsColumns}
		headlineDictionary={columnHeaders}
		key='🎩s'
		sortDictionary={sortKeys}
	/>,
	ContactsTable.ActionTH
]

const CampaignTable_ = ({ contacts, filter, total }: Props) => (
	<>
		<ContactsTable.Wrapper sizeKey='Executions' store={$draftCampaignStyles}>
			<ContactsTable.SelectWrap
				Actions={HeaderActions}
				filter={filter}
				Headers={Headers}
				items={contacts}
				Row={CampaignContactsRow}
				total={total}
			/>
		</ContactsTable.Wrapper>

		<SearchPagination total={total} />
	</>
)

export const CampaignTable = memo(CampaignTable_)
